import { ReactNode } from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { Tooltip } from 'framework/ui/mui-builder';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';

const truncatedTextSx = {
  display: '-webkit-box',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  lineHeight: 1.2,
  wordBreak: 'break-word',
};

const createTruncatedTextFormat =
  (maxLength = 40, typographyProps?: TypographyProps) =>
  (str?: string | null): ReactNode => {
    const safeStr = str || EMPTY_VALUE_INDICATOR;

    return safeStr.length > maxLength ? (
      <Tooltip title={safeStr}>
        <Typography {...typographyProps} sx={[truncatedTextSx]}>
          {safeStr}
        </Typography>
      </Tooltip>
    ) : typographyProps ? (
      <Typography {...typographyProps}>{safeStr}</Typography>
    ) : (
      safeStr
    );
  };

export default createTruncatedTextFormat;
